import React from 'react'
import { Col } from 'react-bootstrap';
function Stepper(props) {
    const stepperLabel = ['Profile', 'Experience', 'Education', 'Skills', 'Summary', 'Finalize'];
    return (
        <>
            <Col md={12} className='stepper-main'>
                <div className='stepper-outer'>
                    <div className="stepper-inner">
                        <ul className="stepper-inner-steps clearfix">
                            {
                                stepperLabel.map((item, index) => 
                                    <li className={Number(props.pagenumber) >= index+1 ? 'active' : ''} key={index}>
                                        <span><i className="fa fa fa-check"></i></span>
                                        <p className="text">{item}</p>
                                    </li>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </Col>
        </>
    )
}

export default Stepper
